module.exports = __webpack_public_path__ + "img/28ne.15901f7f.svg";